import { lazy } from "react";

export const LazyLlmPromptTemplatePage = lazy(
    () =>
        import(
            /* webpackChunkName: "LlmPromptTemplatePage" */ "./LlmPromptTemplatePage"
        )
);
